import { render, staticRenderFns } from "./DistributionPrice.vue?vue&type=template&id=1ef6a5fe&scoped=true"
import script from "./DistributionPrice.vue?vue&type=script&lang=js"
export * from "./DistributionPrice.vue?vue&type=script&lang=js"
import style0 from "./DistributionPrice.vue?vue&type=style&index=0&id=1ef6a5fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef6a5fe",
  null
  
)

export default component.exports